"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skinner = void 0;
const NolimitApplication_1 = require("../NolimitApplication");
const ImgLoader_1 = require("../loader/ImgLoader");
/**
 * Utility for replacing image assets in pixi-texture-cache.
 *
 * For bonus images it will also change the path in game-info to this new asset path.
 *
 * THough there is some extra things you need to do in order for that to work:
 *
 *
 */
class Skinner {
    constructor(validSkinIds) {
        this._validSkinIds = [];
        this._assetPath = "/resources/images/";
        this._validSkinIds = validSkinIds;
    }
    /**
     * Overrides skinId. Should not be done except for jurisdiction requirements such as "gameClientConfiguration.replaceWordFree" where images
     * needs replacing.
     */
    set skinId(value) {
        this._skinId = value;
    }
    /**
     * Return active skin Id if any
     */
    get skinId() {
        if (this._skinId && this._skinId != "") {
            return this._skinId;
        }
        if (NolimitApplication_1.NolimitApplication.apiPlugin.options.extra) {
            let extraData;
            if (typeof NolimitApplication_1.NolimitApplication.apiPlugin.options.extra === "string") {
                extraData = JSON.parse(NolimitApplication_1.NolimitApplication.apiPlugin.options.extra);
            }
            else {
                extraData = NolimitApplication_1.NolimitApplication.apiPlugin.options.extra;
            }
            if ((extraData === null || extraData === void 0 ? void 0 : extraData.campaignId) != undefined) {
                this._skinId = extraData.campaignId.toLowerCase();
            }
        }
        if (this._skinId != undefined && this._validSkinIds.indexOf(this._skinId) < 0) {
            this._skinId = undefined;
        }
        return this._skinId;
    }
    /**
     *
     * @param replaceMap The assets to replace and with what.
     *
     * E.g
     * replaceMap.set("FREESPIN_3_SCATTERS", "FREESPIN_3_SCATTERS.png");
     * this means:
     * Replace asset with name "FREESPIN_3_SCATTERS" with asset: "./resources/images/__SKIN_NAME__/FREESPIN_3_SCATTERS.png".
     *
     * That replaces the texture in the pixi-texture cache and can be used as normal.
     */
    loadSkin(replaceMap) {
        if (this.skinId != undefined) {
            this.addReplaceBuyFeatureImagesListener(replaceMap);
            return this.loadAndReplaceAssets(this._assetPath + this.skinId, replaceMap);
        }
        return Promise.resolve();
    }
    addReplaceBuyFeatureImagesListener(replaceMap) {
        NolimitApplication_1.NolimitApplication.apiPlugin.events.on("screen", (data) => {
            if (data == "open") {
                const gameInfo = document.getElementById("gameInfoContainer");
                const bonus = gameInfo === null || gameInfo === void 0 ? void 0 : gameInfo.getElementsByClassName("noLimitBonus")[0];
                if (bonus && this.skinId != undefined) {
                    const elements = bonus.getElementsByClassName("buyFeatureImage");
                    for (let element of elements) {
                        const imgFileName = element.alt; //This alt value is set in SlotKeypad gui guide template to be the exact feature name
                        if (element.tagName == "IMG" && replaceMap.has(imgFileName)) {
                            element.src = NolimitApplication_1.NolimitApplication.resourcePath + "/resources/images/" + this.skinId + "/" + imgFileName + ".png";
                        }
                    }
                }
                const booster = gameInfo === null || gameInfo === void 0 ? void 0 : gameInfo.getElementsByClassName("noLimitBooster")[0];
                if (booster && this.skinId != undefined) {
                    const elements = booster.getElementsByClassName("buyFeatureImage");
                    for (let element of elements) {
                        const imgFileName = element.alt; //This alt value is set in SlotKeypad gui guide template to be the exact feature name
                        if (element.tagName == "IMG" && replaceMap.has(imgFileName)) {
                            element.src = NolimitApplication_1.NolimitApplication.resourcePath + "/resources/images/" + this.skinId + "/" + imgFileName + ".png";
                        }
                    }
                }
            }
        });
    }
    loadAndReplaceAssets(path, replaceMap) {
        const imgLoader = new ImgLoader_1.ImgLoader(NolimitApplication_1.NolimitApplication.resourcePath);
        replaceMap.forEach((filename, id, key) => {
            imgLoader.add(id + "_rep", path + "/" + filename);
        });
        const promises = Promise.all([imgLoader.load()]);
        return promises.then((values) => {
            replaceMap.forEach((filename, id) => {
                id = id + "_rep";
                let baseTextureNew = PIXI.utils.BaseTextureCache[id];
                const realName = id.replace("_rep", "");
                if (PIXI.utils.TextureCache[realName]) {
                    const newTexture = PIXI.utils.TextureCache[id];
                    const texture = PIXI.utils.TextureCache[realName];
                    texture.baseTexture = baseTextureNew;
                    texture.frame = newTexture.frame;
                    texture.trim = newTexture.trim;
                    texture.updateUvs();
                }
            });
            return Promise.resolve();
        });
    }
}
exports.Skinner = Skinner;
//# sourceMappingURL=Skinner.js.map